import { CurrencyPosition } from '../types/enums/CurrencyPosition';

export const CurrencyConfig = {
  id: 1,
  name: 'US Dollar',
  code: 'USD',
  value: '1',
  symbol: '$',
  decimalPlace: 2,
  position: CurrencyPosition.Left,
};
